<div class="tab-header">
    <div *ngFor="let tab of tabs" class="tab" (click)="selectTabComponent(tab)" [class.active]="tab.active" [active]="tab.active">
        <a>{{tab.title}}</a>
    </div>
    <div class="stretcher"></div>
</div>
<div class="tabs">
    <ng-content></ng-content>
</div>